import { render, staticRenderFns } from "./ImportTextDropdown.vue?vue&type=template&id=0cc01bd2&scoped=true&"
import script from "./ImportTextDropdown.vue?vue&type=script&lang=js&"
export * from "./ImportTextDropdown.vue?vue&type=script&lang=js&"
import style0 from "./ImportTextDropdown.vue?vue&type=style&index=0&id=0cc01bd2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc01bd2",
  null
  
)

export default component.exports